import { callWebUtils } from "../../Actions";
import { ActionsProfile } from "./ActionsProfile";

export const ActionsListenersProfile = () => {
  ActionsProfile.createProfile.listen(function (data) {
    return callWebUtils(this, "createProfile", [data]);
  });

  ActionsProfile.patchProfile.listen(function (profileId, data) {
    return callWebUtils(this, "patchProfile", [profileId, data]);
  });

  ActionsProfile.deleteProfile.listen(function (profileId) {
    return callWebUtils(this, "deleteProfile", [profileId]);
  });

  ActionsProfile.getProfilesByOrganizationId.listen(function (organizationId) {
    return callWebUtils(this, "getProfilesByOrganizationId", [organizationId]);
  });

  ActionsProfile.getProfileByOrganizationId.listen(function (profileId, organizationId) {
    return callWebUtils(this, "getProfileByOrganizationId", [profileId, organizationId]);
  });

  ActionsProfile.getDomainSkillsByJobCategoryId.listen(function (jobCategoryId) {
    return callWebUtils(this, "getDomainSkillsByJobCategoryId", [jobCategoryId]);
  });

  ActionsProfile.generateWhatsappForm.listen(function (profileId) {
    return callWebUtils(this, "generateWhatsappForm", [profileId]);
  });

  ActionsProfile.createDomainSkill.listen(function (domainSkillData) {
    return callWebUtils(this, "createDomainSkill", [domainSkillData]);
  });

  ActionsProfile.getCategoriesByJobCategoryId.listen(function (jobCategoryId) {
    return callWebUtils(this, "getCategoriesByJobCategoryId", [jobCategoryId]);
  });
};
